import { AdvertisementTypeEnum } from "@app/types/enums";
import SMELogo from "@assets/logo-sme.svg";
import Advertisement from "@components/Advertisement/Advertisement";
import PrestitialAd from "@components/Advertisement/PrestitialAd";
import Banner from "@components/Banner/Banner";
import SectionMasthead from "@components/SectionMasthead/SectionMasthead";
import useOKTAUserStore, { OKTAUserTypeEnum } from "@store/useOKTAUserStore";
import { sectionNavigationItems } from "@util/constant";
import { GoogleAdsSlotFactory } from "@util/helpers";
import cx from "classnames";

export default function SMEBanner(): React.ReactElement {
  const OKTAUserInfo = useOKTAUserStore((state) => state.userInfo);
  const slot = sectionNavigationItems["singapore/smes"]
    ? GoogleAdsSlotFactory.lb1(
        sectionNavigationItems["singapore/smes"].link
          .split("/")
          .filter((a) => a !== "")
          .join("/")
      )
    : null;
  return (
    <>
      {sectionNavigationItems["singapore/smes"] ? (
        <SectionMasthead
          link={sectionNavigationItems["singapore/smes"].link}
          masthead={{
            alt: "SGSME logo",
            src: SMELogo,
            width: 126,
            height: 31,
          }}
        />
      ) : null}

      {slot ? (
        <>
          <Advertisement
            rootClassName="pt-6"
            adUnitProps={{
              type: AdvertisementTypeEnum.LB1,
              slot: slot,
            }}
          />

          {OKTAUserInfo?.usertype !== OKTAUserTypeEnum.SUBSCRIBER ? (
            <PrestitialAd slot={slot} />
          ) : null}
        </>
      ) : null}

      <Banner
        rootClassName="w-full bg-gray-250 border-b-2 border-red text-center pb-2 mb-7 lg:mb-8"
        dismissable
      >
        <>
          <div>
            <b>亲爱的SME聚汇读者：</b>
          </div>

          <div className="flex flex-col items-center justify-center gap-y-4 px-8 font-poppins lg:flex-row">
            <div className="md:pr-4">
              {"请点击前往 "}
              <a
                href="https://zaobao.com.sg/finance/sme"
                target="_blank"
                className="text-red"
                rel="noreferrer"
              >
                zaobao.com.sg/finance/sme
              </a>
              {" 获取更多华文的SME最新消息。"}
              <br />
              {"此外，也请继续关注我们的中英双语面簿页面 "}
              <a
                href="https://facebook.com/sgsme.sg"
                target="_blank"
                className="text-red"
                rel="noreferrer"
              >
                facebook.com/sgsme.sg
              </a>
            </div>
            <a
              className={cx(
                "rounded-pill border border-red bg-red px-8 py-1 text-white transition-colors",
                "hover:bg-white hover:text-red"
              )}
              href="https://www.zaobao.com.sg/finance/sme"
              target="_blank"
              rel="noreferrer"
            >
              好的
            </a>
          </div>
        </>
      </Banner>
    </>
  );
}
